import React, { useRef, useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import styles from './GlobalSearchResult.module.css'
import classNames from 'classnames'
import { Button, ConfigProvider, Input, message, Modal } from 'antd'
import { LeftOutlined } from '@ant-design/icons'
import locale from 'antd/locale/zh_CN'
import {
  cancelCollectCardRequest,
  collectCardRequest,
  getVideoPlayerAuthRequest,
  searchRequest,
  updateAppLogRequest,
} from './api'
import ListItem from './ListItem'
import { HTTP_URL } from '../../../util/constants'
import CommentInfoDrawr from './CommentInfoDrawer'
import BotItem from './BotItem'
import { setShowPlayerModalStatus, setVideoId } from '../../PlayerModal/PlayerModalSlice'
import Cookies from 'js-cookie';
export default function GlobalSearchResult(props) {
  const dispatch = useDispatch()
  const wdzpListRef = useRef(null)
  const [zpCardWidth, setZpCardWidth] = useState(window.innerWidth - 240 - 98)
  const [searchStr, setSearchStr] = useState('')
  const [searchResult, setSearchResult] = useState({
    coze_yingyong: [],
    putong_yingyong: [],
    waibuyingyong_arr: [],
  })
  const [showVideo, setShowVideo] = useState(false)
  const [drawerStatus, setDrawerStatus] = useState(false)
  const [drawerInfo, setDrawerInfo] = useState({})

  useEffect(() => {
    // 在这里执行你的组件挂载后的逻辑
    // 这里可以返回一个清理函数，它会在组件卸载前执行
    window.addEventListener('resize', handleResize)
    setSearchStr(props.searchStr)
    confirmSearch(props.searchStr)
    return () => {
      window.removeEventListener('resize', handleResize)
      // console.log('组件即将卸载');
    }
  }, []) // 空数组意味着这个 effect 只会在组件挂载时执行一次

  function handleResize() {
    if (wdzpListRef.current) {
      console.log(window.innerWidth)
      const width = wdzpListRef.current.offsetWidth
      setZpCardWidth(width)
    }
  }

  function confirmSearch(namekey) {
    if (namekey === '') {
      message.error('请输入搜索内容')
      return
    } else {
      searchRequest(namekey, (res) => {
        if (res.ret == 1) {
          setSearchResult(res.data)
          console.log(searchResult)
        } else {
          message.error(res.msg)
        }
      })
    }
  }

  function selectItem(params, yingyong_type) {
    console.log(params)
    if (params.link_url.includes('http')) {
      if (yingyong_type == 1) {
        window.open(HTTP_URL + '/app?id=' + params.code)
      } else if (yingyong_type == 2) {
        updateAppLogRequest(yingyong_type, params, (data) => {
          if (data.ret == 1) {
            window.open(params.link_url)
          } else {
            message.info(data.msg)
          }
        })
      }
    } else {
      message.info('请配置应用链接')
    }
  }

  function collectMethod(params, yingyong_type) {
    if (params.shoucang_status == 0) {
      collectCardRequest(yingyong_type, params.code, (data) => {
        if (data.ret == 1) {
          // getCardInfoList()
          message.info('收藏成功')
          setSearchResult({
            ...searchResult,
            putong_yingyong: searchResult.putong_yingyong.map((item) => {
              if (item.code == params.code) {
                return {
                  ...item,
                  shoucang_status: 1,
                }
              } else {
                return item
              }
            }),
            waibuyingyong_arr: searchResult.waibuyingyong_arr.map((item) => {
              if (item.code == params.code) {
                return {
                  ...item,
                  shoucang_status: 1,
                }
              } else {
                return item
              }
            }),
          })
        } else {
          message.info(data.msg)
        }
      })
    } else {
      cancelCollectCardRequest(params.code, (data) => {
        if (data.ret == 1) {
          message.info('取消收藏成功')
          setSearchResult({
            ...searchResult,
            putong_yingyong: searchResult.putong_yingyong.map((item) => {
              if (item.code == params.code) {
                return {
                  ...item,
                  shoucang_status: 0,
                }
              } else {
                return item
              }
            }),
            waibuyingyong_arr: searchResult.waibuyingyong_arr.map((item) => {
              if (item.code == params.code) {
                return {
                  ...item,
                  shoucang_status: 0,
                }
              } else {
                return item
              }
            }),
          })
        } else {
          message.info(data.msg)
        }
      })
    }
  }
  function playVideo(videoUrl) {
    dispatch(setShowPlayerModalStatus(true))
    dispatch(setVideoId(videoUrl))
  }
  function openDrawer(info, yingyong_type) {
    setDrawerStatus(true)
    setDrawerInfo({
      ...info,
      yingyong_type: yingyong_type,
    })
  }

  const clickBotItem = (info) => {
    window.open(
      HTTP_URL +
        `gongju/preview/index.html?botId=${info.bot_id}&icon=${btoa(info.icon_url)}&title=${info.bot_name}&userToken=${Cookies.get("userToken")}`,
    )
    setSearchResult({
      ...searchResult,
      coze_yingyong: searchResult.coze_yingyong.map((item) => {
        if (item.bot_id == info.bot_id) {
          return {
            ...item,
            open_time: parseInt(item.open_time) + 1,
          }
        } else {
          return item
        }
      }),
    })
    // let tempList = botList.map((item) => {
    //   if (item.bot_id == info.bot_id) {
    //     item.open_time = parseInt(item.open_time) + 1
    //   }
    //   return item
    // })
    // setBotList(tempList)
  }
  return (
    <div className={styles.background}>
      <div>
        <Button
          onClick={() => {
            props.onCancel()
          }}
          icon={<LeftOutlined />}
          type="text"
          style={{
            fontSize: 20,
          }}
        >
          搜索结果
        </Button>
        <ConfigProvider
          locale={locale}
          theme={{
            components: {
              Form: {
                labelFontSize: 18,
              },
            },
          }}
        >
          <Input.Search
            enterButton
            onSearch={confirmSearch.bind(null, searchStr)}
            size="large"
            placeholder="查你想知道的..."
            className={styles.searchInput}
            onChange={(e) => {
              setSearchStr(e.target.value)
            }}
            onPressEnter={confirmSearch.bind(null, searchStr)}
            value={searchStr}
          />
        </ConfigProvider>
      </div>
      {props.searchType == 1 ? (
        <div className={styles.searchResult}>
          <div className={styles.searchResultTitle}>
            共搜索到{searchResult.putong_yingyong.length}条甄选应用结果
          </div>
          <div className={styles.itemContainer} ref={wdzpListRef}>
            {searchResult.putong_yingyong.map((item1, index) => {
              return (
                <ListItem
                  showPoints={true}
                  info={item1}
                  boxWidth={zpCardWidth}
                  clickMethod={selectItem.bind(null, item1, '1')}
                  collectMethod={collectMethod.bind(null, item1, '1')}
                  playVideo={playVideo}
                  openDrawer={openDrawer.bind(null, item1, '1')}
                />
              )
            })}
          </div>
        </div>
      ) : props.searchType == 2 ? (
        <div className={styles.searchResult}>
          <div className={styles.searchResultTitle}>
            共搜索到{searchResult.waibuyingyong_arr.length}条待评测应用结果
          </div>
          <div className={styles.itemContainer} ref={wdzpListRef}>
            {searchResult.waibuyingyong_arr.map((item1, index) => {
              return (
                <ListItem
                  showPoints={false}
                  info={item1}
                  boxWidth={zpCardWidth}
                  clickMethod={selectItem.bind(null, item1, '2')}
                  collectMethod={collectMethod.bind(null, item1, '2')}
                  playVideo={playVideo}
                  openDrawer={openDrawer.bind(null, item1, '2')}
                />
              )
            })}
          </div>
        </div>
      ) : (
        <div className={styles.searchResult}>
          <div className={styles.searchResultTitle}>
            共搜索到{searchResult.coze_yingyong.length}条教育智能体结果
          </div>
          <div className={styles.itemContainer} ref={wdzpListRef}>
            {searchResult.coze_yingyong.map((item, index) => {
              return (
                <BotItem
                  key={index}
                  info={item}
                  clickBotMethod={clickBotItem}
                />
              )
            })}
          </div>
        </div>
      )}

      {props.searchType != 1 ? (
        <div className={styles.searchResult}>
          <div className={styles.searchResultTitle}>
            共搜索到{searchResult.putong_yingyong.length}条甄选应用结果
          </div>
          <div className={styles.itemContainer} ref={wdzpListRef}>
            {searchResult.putong_yingyong.map((item1, index) => {
              return (
                <ListItem
                  showPoints={true}
                  info={item1}
                  boxWidth={zpCardWidth}
                  clickMethod={selectItem.bind(null, item1, '1')}
                  collectMethod={collectMethod.bind(null, item1, '1')}
                  playVideo={playVideo}
                  openDrawer={openDrawer.bind(null, item1, '1')}
                />
              )
            })}
          </div>
        </div>
      ) : null}

      {props.searchType != 2 ? (
        <div className={styles.searchResult}>
          <div className={styles.searchResultTitle}>
            共搜索到{searchResult.waibuyingyong_arr.length}条待评测应用结果
          </div>
          <div className={styles.itemContainer} ref={wdzpListRef}>
            {searchResult.waibuyingyong_arr.map((item1, index) => {
              return (
                <ListItem
                  showPoints={false}
                  info={item1}
                  boxWidth={zpCardWidth}
                  clickMethod={selectItem.bind(null, item1, '2')}
                  collectMethod={collectMethod.bind(null, item1, '2')}
                  playVideo={playVideo}
                  openDrawer={openDrawer.bind(null, item1, '2')}
                />
              )
            })}
          </div>
        </div>
      ) : null}
      {props.searchType != 3 ? (
        <div className={styles.searchResult}>
          <div className={styles.searchResultTitle}>
            共搜索到{searchResult.coze_yingyong.length}条教育智能体结果
          </div>
          <div className={styles.itemContainer} ref={wdzpListRef}>
            {searchResult.coze_yingyong.map((item, index) => {
              return (
                <BotItem
                  key={index}
                  info={item}
                  clickBotMethod={clickBotItem}
                />
              )
            })}
          </div>
        </div>
      ) : null}
      <CommentInfoDrawr
        info={drawerInfo}
        drawerStatus={drawerStatus}
        close={() => {
          setDrawerStatus(false)
        }}
        refreshMethod={(e) => {
          confirmSearch(searchStr)
        }}
      />
    </div>
  )
}
